import React from 'react'
import { useTranslation } from 'react-i18next'

import { DatasetCategory } from 'src/commons/chartjs'
import TemporalStackedHistogram from 'src/commons/graphs/TemporalStackedHistogram'
import { IGraphStack } from 'src/commons/types'

export function NumberOfTripsWithLocationSensors(props: IGraphStack) {
  const { t } = useTranslation()
  return (
    <TemporalStackedHistogram
      title={props.title}
      rawData={props.graphReport}
      granularity={props.granularity}
      enableAnimation={props.enableAnimation}
      datasetCategory={DatasetCategory.location_types}
      formatLabel={(x: string) => t(`locationType.${x}`, x)}
    />
  )
}

export function NumberOfTripsWithLocationSensorsPercentage(props: IGraphStack) {
  const { t } = useTranslation()
  return (
    <TemporalStackedHistogram
      title={props.title}
      rawData={props.graphReport}
      granularity={props.granularity}
      adjacentBars={true}
      enableAnimation={props.enableAnimation}
      formatWithUnit={(number) => `${number}%`}
      datasetCategory={DatasetCategory.location_types}
      formatLabel={(x: string) => t(`locationType.${x}`, x)}
    />
  )
}
